import angular from "angular";

import OrganisationOwnerServiceApplicationsRouting from "./organisation-owner-applications.module.routing";

export default angular
  .module("vt-organisation-owner-applications", [])
  .config(OrganisationOwnerServiceApplicationsRouting);
